// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { fromJS, OrderedMap } from "immutable"
import { createSelector } from "reselect"
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"
import type { OutputSelector } from "reselect"

import type { LanguageInfo } from "../../records/LanguageInfo"
import type { Phone, Phones } from "../../records/Phone"
import type { StringMap } from "../../records/StringMap"
import type { Continents } from "../../records/Continent"
import type { Airlines } from "../../records/Airline"

export type StaticDataState = {
  readonly continents: Continents
  readonly countries: StringMap
  readonly countryCurrencies: StringMap
  readonly countryPhonePrefixes: StringMap
  readonly airlineTerms: StringMap
  readonly currencies: FetchedCurrencies
  readonly languageInfo: LanguageInfo
  readonly languageCountries: StringMap
  readonly languageNames: StringMap
  readonly phones: Phones
  readonly phonesOrder: string[]
  readonly airlines: Airlines
}

const initialState = {
  airlineTerms: {},
  countries: {},
  continents: {},
  countryCurrencies: {},
  countryPhonePrefixes: {},
  currencies: {},
  languageInfo: {
    // 'null' would require too much refactoring
    id: "en",
    name: "English",
    displayName: "English",
    phone: "gb",
    email: "en",
    defaultCountry: "gb",
    api: "en",
    moment: "en-gb",
    jumio: "en_GB",
    nginx: "en",
    countriesTranslations: "EN",
    translations: "en",
    phraseApp: "en-US",
    canonical: "",
    hreflang: "en-US",
    iso: "en-US",
    locations: "en",
    dateFormat: "iii' 'd' 'LLL",
    dateFormatShort: "d'/'L",
    dateFormatLong: "dd'.'LL'.'yyyy",
    dateFormatPlain: "P",
    timeFormat: "p",
    durationFormat: "H[h] mm[m]",
    durationFormatShort: "m[m] ss[s]",
    dimension: "__x__ cm",
    weight: "__x__ kg",
    latinInputs: false,
    currency: "gbp",
    direction: "ltr",
    flag: "gb",
    fontSubsets: "greek,latin-ext",
    firstNamePlaceholder: "Harry James",
    lastNamePlaceholder: "Brown",
    addressPlaceholder: "71 Wall Stt",
    cityPlaceholder: "New York",
    zipCodePlaceholder: "10005",
    idNumberPlaceholder: "1234567890",
    companyVatPlaceholder: "10007",
    companyNamePlaceholder: "Kiwi.com",
    distanceUnit: "__x__ km",
    distanceUnitConversionRate: "1",
    elevioLang: "",
    specialFont: "",
    decimalSeparator: ".",
    thousandsSeparator: ",",
    separateFourDigits: "1",
  },
  languageCountries: {},
  languageNames: {},
  phones: {},
  phonesOrder: [],
  airlines: {},
} as const

// @ts-expect-error: Flow to TS migration.
function staticDataReducer(state: StaticDataState = initialState) {
  return state
}

export default staticDataReducer

type State = {
  readonly staticData: StaticDataState
}

const getState = (state: State) => state.staticData

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getContinents: OutputSelector<State, any, Continents> = createSelector(
  getState,
  (data) => data.continents,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCountries: OutputSelector<State, any, StringMap> = createSelector(
  getState,
  (data) => data.countries,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCountriesMap: OutputSelector<State, any, OrderedMap> = createSelector(
  getCountries,
  // FIXME: a method has been detected that possibly mutates the object, consider a more functional
  // approach (Ramda might help)

  (data) => OrderedMap(fromJS(data)).sort(),
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCountryCurrencies: OutputSelector<State, any, StringMap> = createSelector(
  getState,
  (data) => data.countryCurrencies,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLanguageInfo: OutputSelector<State, any, LanguageInfo> = createSelector(
  getState,
  (data) => data.languageInfo,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCountryPhonePrefixes: OutputSelector<State, any, StringMap> = createSelector(
  getState,
  (data) => data.countryPhonePrefixes,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLanguageCountries: OutputSelector<State, any, StringMap> = createSelector(
  getState,
  (data) => data.languageCountries,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getLanguageNames: OutputSelector<State, any, StringMap> = createSelector(
  getState,
  (data) => data.languageNames,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAirlineTerms: OutputSelector<State, any, StringMap> = createSelector(
  getState,
  (data) => data.airlineTerms,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrencies: OutputSelector<State, any, FetchedCurrencies> = createSelector(
  getState,
  (data) => data.currencies,
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSortedPhones: OutputSelector<State, any, Phone[]> = createSelector(
  getState,
  (data) => data.phonesOrder.map((id) => data.phones[id]),
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAirlines: OutputSelector<State, any, Airlines> = createSelector(
  getState,
  (data) => data.airlines,
)
